import { BottomDrawerMenu, DrawerMenu } from '@components/Drawer'
import { Avatar, Backdrop, styled } from '@mui/material'
import { AccountDto, AccountRoleEnum, ClientDto } from '@services/api'
import CardStateService from '@services/CardStateService'
import { Actions } from '@state/actions'
import { setInsertedCards } from '@state/reducers/appReducer'
import { doGetMemberPreferences } from '@state/reducers/memberPreferencesReducer'
import { useSelector } from '@state/store'
import { findMyInfos } from '@state/thunks/authThunk'
import { startScannerService } from '@state/thunks/ScannerThunk'
import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { Navigate, Outlet } from 'react-router-dom'
import Logo from '../assets/img/logos/logo.png'

const StyledAvatar = styled(Avatar)(() => ({
  animation: '$animation 2s ease-in-out alternate infinite',
  '@keyframes animation': {
    from: {
      transform: 'scale(1)',
    },
    to: {
      transform: 'scale(2)',
    },
  },
}))
const StyledBackdrop = styled(Backdrop)(({ theme }) => ({
  zIndex: theme.zIndex.drawer + 1,
  color: '#fff',
}))

export default function AppLayout() {
  const dispatch = useDispatch()
  const { isAuth, loading, account, user } = useSelector(
    ({ auth, client, loading }) => ({
      isAuth: auth.isAuth,
      account: auth.account as AccountDto,
      client: client.selected as ClientDto,
      profile: auth.account as AccountDto,
      user: auth.user,
      loading: loading[Actions.FIND_MY_INFOS],
    }),
  )

  useEffect(() => {
    if (isAuth) {
      dispatch(findMyInfos())
      dispatch(doGetMemberPreferences())
      dispatch(startScannerService())
    }
    const cardService = new CardStateService()
    cardService.onCardUpdate((cards) => {
      dispatch(setInsertedCards(cards))
    })
    cardService.connect('ws://localhost:8096')

    return () => {
      cardService.disconnect()
    }
  }, [dispatch, isAuth])

  if (!isAuth) return <Navigate to={{ pathname: '/auth/login' }} />

  if (loading)
    return (
      <StyledBackdrop open={true}>
        <StyledAvatar src={Logo} alt="logo" />
      </StyledBackdrop>
    )
  return (
    <>
      <DrawerMenu role={account.role as AccountRoleEnum} />
      <div className="ml-14">
        <Outlet />
      </div>
      <BottomDrawerMenu user={user} />
    </>
  )
}
